'use client';

import { type ReactNode, useRef } from 'react';

import clsx from 'clsx';
import {
  exportComponentAsJPEG,
  exportComponentAsPNG,
} from 'react-component-export-image';

import { Button } from '@kit/ui/button';

import './theme.css';
import s from './tweet-container.module.css';

type Props = {
  className?: string;
  allowExport?: boolean;
  children: ReactNode;
};

export const TweetContainer = ({ className, allowExport, children }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  if (typeof window === 'undefined') {
    return null;
  }

  const theme = localStorage.getItem('theme');

  const onExport = (ref, type) => {
    const exportFunction =
      type === 'jpeg' ? exportComponentAsJPEG : exportComponentAsPNG;
    const svgElements = document.body.querySelectorAll('svg');
    svgElements.forEach(function (item) {
      item.setAttribute(
        'width',
        item?.getBoundingClientRect().width.toString(),
      );
      item.setAttribute(
        'height',
        item?.getBoundingClientRect().height.toString(),
      );
      item.style.width = null;
      item.style.height = null;
    });

    exportFunction(ref, {
      fileName: 'tweet.jpeg',
      html2CanvasOptions: {
        backgroundColor: theme === 'light' ? '#FFFFFF' : 'rgb(21, 32, 43)',
      },
    });
  };

  if (allowExport) {
    return (
      <div className="flex flex-col gap-y-6">
        <div className="flex justify-center gap-x-6">
          <Button variant="secondary" onClick={() => onExport(ref, 'jpeg')}>
            Export JPEG
          </Button>
          <Button variant="secondary" onClick={() => onExport(ref, 'png')}>
            Export PNG
          </Button>
        </div>
        <div className={clsx('react-tweet-theme', s.root, className)} ref={ref}>
          <article className={clsx(s.article)}>{children}</article>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={clsx('react-tweet-theme w-full border', s.root, className)}
        ref={ref}
      >
        <article className={s.article}>{children}</article>
      </div>
    );
  }
};
